import { Msg } from 'react-weui';

function P404() {
  return <Msg type="warn" title="页面不存在" />;
}

export default P404;
